import { Brand, StoredFile } from '../../file/model';

export function getBrandsAndModels(files?: StoredFile[]) {
  if ((!files || files.length === 0)) {
    return [];
  }

  const brands = files.reduce((acc, file) => {
    if (!file.brand) {
      return acc;
    }

    const existingBrand = acc.find((item) => {
      return item.name === file.brand;
    });

    if (!existingBrand) {
      const brand: Brand = {
        name: file.brand,
        models: file.models || []
      };

      acc.push(brand);
    } else {
      file?.models.forEach((model) => {
        insertModelIfNotExists(existingBrand, model);
      });
    }

    return acc;
  }, [] as Brand[]);

  brands.forEach((brand) => {
    brand.models = brand.models.sort((a, b) => a.localeCompare(b));
  })

  return brands.sort((a, b) => a.name.localeCompare(b.name));
}

function insertModelIfNotExists(
  brand: Brand,
  model: string
): Brand {
  const newBrand = { ...brand };

  if (!brand.models.includes(model)) {
    newBrand.models.push(model);
  }

  return newBrand;
}
